import { render } from "./MemberEditProfile.vue?vue&type=template&id=33b206b2"
import script from "./MemberEditProfile.vue?vue&type=script&lang=js"
export * from "./MemberEditProfile.vue?vue&type=script&lang=js"

import "./MemberEditProfile.vue?vue&type=style&index=0&id=33b206b2&lang=css"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__